import BasePlayerUi from '../player/basePlayerUI';
import ScaleManager from '../../../scaleManager/ScaleManager';

export default class PortraitUi extends BasePlayerUi {
  constructor({ config, partnerConfig }) {
    super({ config, partnerConfig });

    this._config = {
      ...this._config,
      offsets: {
        top: 0,
        left: 0,

        tournaments_panel: {
          top: 0,
          left: 0,
          scale: 1,
        },
        freebets_panel: {
          top: 0,
          left: 0,
        },
        top_panel: {
          top: 0,
          left: 0,
        }
      },
    };

    if (config) {
      this._config.offsets = {
        ...this._config.offsets, ...config.offsets,
        tournaments_panel: { ...this._config.offsets.tournaments_panel, ...config.offsets.tournaments_panel },
        freebets_panel: { ...this._config.offsets.freebets_panel, ...config.offsets.freebets_panel },
        top_panel: { ...this._config.offsets.top_panel, ...config.offsets.top_panel },
      };
    }

    this.init();
  }

  init(container) {
    super.init(container);
    this.root.setAttribute('data-orientation', 'portrait');
  }

  set scaleData(value) {
    super.scaleData = value;
    const uiContainer = this.root.querySelector('.ui-container__portrait');
    const topContainer = this.root.querySelector('.ui-container__portrait_top');

    let marginY = (this._scaleData.stageY / this._scaleData.uiScale) - 630 // (2340 - 1080) / 2   - portrait Y offset inside .fla
    if (marginY < 0) marginY = 0;

    document.documentElement.style.setProperty(`--scale--game--width`, ScaleManager.config.CANVAS_HEIGHT_FOR_UI_PORTRAIT / ScaleManager.defaultFontSize);

    if (uiContainer) {
      uiContainer.style.width = `${(ScaleManager.safeZone.width / ScaleManager.defaultFontSize) / this._scaleData.uiScaleRelativeToCanvasScale}rem`;
      uiContainer.style.margin = `0 auto ${marginY / ScaleManager.defaultFontSize}rem`;
    }
    if (topContainer) {
      topContainer.style.width = `${(ScaleManager.safeZone.width / ScaleManager.defaultFontSize) / this._scaleData.uiScaleRelativeToCanvasScale}rem`;
      topContainer.style.margin = `${marginY / ScaleManager.defaultFontSize}rem auto 0`;
    }
  }

  _getAutoplayButtonMarkup() {
    return this._excludedControllerTypes.has(this.controllerTypes.ECT_AUTO_SPIN) ?
      '' :
      `<div id=${this.controllersContainersIds[this.controllerTypes.ECT_AUTO_SPIN]}></div>`
  }

  _getTurboPlayButtonMarkup() {
    return this._excludedControllerTypes.has(this.controllerTypes.ECT_TURBO_SPIN) ?
      '' :
      `<div id=${this.controllersContainersIds[this.controllerTypes.ECT_TURBO_SPIN]}></div>`
  }

  _getConstantMarkup() {
    return `<div class="ui-container__tournaments_label_container" data-orientation="portrait" style="--scale: ${this._config.offsets.tournaments_panel.scale}; top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.left)}rem">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_TOURNAMENTS_LABEL]}>
      </div>
    </div>

    <div class="ui-container__freebets_panel" id=${this.controllersContainersIds[this.controllerTypes.ECT_FREEBETS_PANEL]} style="position: fixed; width: 100%; bottom: 0; left: 0;"></div>`
  }

  _getMarkup() {
    return `
    <div class="ui-container__tournaments_label_container" data-orientation="portrait" style="--scale: ${this._config.offsets.tournaments_panel.scale}; top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.tournaments_panel.left)}rem">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_TOURNAMENTS_LABEL]}>
      </div>
    </div>
    
        <!--            modals-->
    <div class="ui-container__bet_selector_container" data-orientation="portrait" style="padding-bottom: ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.top)}rem">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_BET_SELECTOR_TABLE]}>
      </div>
    </div>
    <div class="ui-container__auto_play_table" data-orientation="portrait" style="padding-bottom: ${window.OPWrapperService.ScaleManager.convertPxToRem(-this._config.offsets.top)}rem">
      <div id=${this.controllersContainersIds[this.controllerTypes.ECT_AUTO_PLAY_TABLE]}>
      </div>
    </div>
    
    <div class="ui-container__portrait_top" style="transform: translate(${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.top_panel.left)}rem, ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.top_panel.top)}rem);">
      <!--    fullscreen    -->
      <div class="ui-container__controller_fullscreen" id=${this.controllersContainersIds[this.controllerTypes.ECT_FULL_SCREEN]}>
      </div>
    </div>
    
<!--    main block-->
    <div class="ui-container__portrait">
      <div class="ui-container__portrait__container" style="top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.left)}rem">
      
        <div class="ui-container__freebets_panel" id=${this.controllersContainersIds[this.controllerTypes.ECT_FREEBETS_PANEL]} style="top: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.freebets_panel.top)}rem; left: ${window.OPWrapperService.ScaleManager.convertPxToRem(this._config.offsets.freebets_panel.left)}rem"></div>
      
        <div class="ui-container__portrait__container__top_block">
        <!--      balance     -->
          <div class="ui-container__controller_balance" id=${this.controllersContainersIds[this.controllerTypes.ECT_BALANCE]}>
          </div>
          <!--      bet     -->
          <div class="ui-container__controller_bet" id=${this.controllersContainersIds[this.controllerTypes.ECT_BET]}>
          </div>
        </div>
        
        <div class="ui-container__portrait__container__center_block">
          <!--      menu button    -->
          <div class="ui-container__controller_menu" id=${this.controllersContainersIds[this.controllerTypes.ECT_MENU]} data-orientation="landscape">
          </div>
          <!--    turbo play   -->
          ${this._getTurboPlayButtonMarkup()}
          <!--    spin    -->
          <div class="ui-container__controller_spin" id=${this.controllersContainersIds[this.controllerTypes.ECT_SPIN]}>
          </div>
          <!--    autoplay    -->
          ${this._getAutoplayButtonMarkup()}
          <!--      coins button     -->
          <div class="ui-container__controller_bet_selector" id=${this.controllersContainersIds[this.controllerTypes.ECT_BET_SELECT]}>
          </div>
        </div>
        
        <div class="ui-container__portrait__container__bottom_block">
<!--          sound-->
          <div class="ui-container__controller_sound" id=${this.controllersContainersIds[this.controllerTypes.ECT_SOUND]}>
          </div>
          <!--      win / last win     -->
          <div class="top_container" id=${this.controllersContainersIds[this.controllerTypes.ECT_WIN]}>
          </div>
                   <!--      info    -->
          <div class="ui-container__controller_info" id=${this.controllersContainersIds[this.controllerTypes.ECT_INFO]}>
          </div>
        </div>
      </div>
      
    </div>
    `
  }
}
